import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { LOGIN_URL } from './constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: module.hot ? '/front' : '/',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'form' },
    },
    {
      path: '/form',
      name: 'form',
      component: () => import(/* webpackChunkName: "benevolence_request_form" */ './views/BenevolenceRequestForm.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/benevolence-change-form/:id-:token',
      name: 'benevolence-change-form',
      component: () => import(/* webpackChunkName: "benevolence_change_form" */ './views/BenevolenceChangeForm.vue'),
      props: route => ({
        routeProjectId: route.params.id,
        routeEditToken: route.params.token,
      }),
    },
    {
      path: '/poc-info-form/:id-:token',
      name: 'poc-info-form',
      component: () => import(/* webpackChunkName: "poc_info_form" */ './views/BenevolencePocInfoForm.vue'),
      props: route => ({
        routeProjectId: route.params.id,
        routeInfoToken: route.params.token,
      }),
    },
  ],
})

router.beforeEach((to, from, next) => {
  const checkAuth = () => {
    const { user } = store.state

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (user === null) {
        location.href = LOGIN_URL
        return
      }

      return next()
    }

    next()
  }

  if (!store.state.initialized) {
    store.dispatch('initialize').then(() => {
      checkAuth()
    })
  } else {
    checkAuth()
  }
})

export default router
